import { forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import "../../style/common/SuccessfulModal.scss";
import { focusElemnt } from '../../utilityFunctions';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SuccessfulModal = (props) => {
    const { onClose, open, dialogConfirmationMessage = '', width = 'auto', height = 'auto', backgroundColor = '#fff', buttonText = 'ok',zIndex='1300', ...other } = props;
    useEffect(() => {
        focusElemnt('OKBtn')
    }, [])
    const handleOk = () => {
        onClose(true);
    };

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: width, height: height, borderRadius: '10px', backgroundColor: backgroundColor,zIndex:zIndex } }}
            maxWidth="xs"
            TransitionComponent={Transition}
            open={open}
            {...other}
        >
            <DialogContent dividers>
                {dialogConfirmationMessage}
                <div className="dialog-confirm"><Button id='OKBtn' onClick={handleOk}>{buttonText}</Button></div>
            </DialogContent>
        </Dialog>
    )
}

export default SuccessfulModal